import styled, { x } from '@xstyled/styled-components';
import React from 'react';
import { IMAGE_MAP } from '..';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import {
  SequenceStore,
  useSequenceStore
} from '~/training/sequence/SequenceStore';
import { select } from '~/lib/select';

interface Props {
  imageUrl: string;
  body?: string;
  w?: string;
  h?: string;
}

export type ImageMapDefinition = ItemDefinition<typeof IMAGE_MAP, Props>;

const Background = styled.div<{ imageUrl: string; w: string; h: string }>`
  width: ${p => p.w};
  height: ${p => p.h};
  background-size: cover;
  background-position: center;
  background-image: url(${p => p.imageUrl});
  filter: brightness(1) !important;
`;

const Instructions = styled.div`
  position: fixed;
  left: 50%;
  top: 60px;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  background-color: white;
  padding: 10px 25px;
  border-radius: 20px;
  opacity: 0.8;
`;

const sequenceSelector = (s: SequenceStore) => select(s, 'blockers');

export class ImageMap extends Item<typeof IMAGE_MAP, Props> {
  protected render({
    imageUrl,
    body,
    children,
    w = '100%',
    h = '100vh'
  }: RenderProps<Props>) {
    const { blockers } = useSequenceStore(sequenceSelector);

    return (
      <x.div w="100%" h="100%" overflow="auto">
        <x.div position="relative">
          <Background className="bgImage" imageUrl={imageUrl} w={w} h={h} />
          {children}
          {blockers.length > 0 && body && <Instructions>{body}</Instructions>}
        </x.div>
      </x.div>
    );
  }
}

registry[IMAGE_MAP] = ImageMap;
